export enum EventTimeMoment {
  TODAY = 'TODAY',
  PAST = 'PAST',
  FUTURE = 'FUTURE'
}